"use strict";

require("babel-polyfill");

// Include required Font Awesome 5 resources for iconography

// Web Font Version - works better for Pseudo Elements:
// require('./sass/font-awesome-webfonts.scss')
// Pro Fonts
require("@fortawesome/fontawesome-pro/css/light.css");
// require("@fortawesome/fontawesome-pro/css/brands.css");
// This is the "common" entry-point for webpack
// It should include all common, shared and vendor resources to be webpack-ed, that are not specific to this app.

// Ensure support for "async" and friends (required now by ValidatorJS)
require("@fortawesome/fontawesome-pro/css/fontawesome.css");

// CSS for JSON Markup helper
require('json-markup/style.css');

// Which set of core static resources to load based on layout
require('./layouts/mais');

// JavaScript core support for "MAIS" page style elements
// require('./js/mais.js')

module.exports = exports = {
   // Hook to allow triggering actions on page load
   onDocumentReady: function onDocumentReady(callback) {
      $(document).ready(callback);
   },
   jQuery: jQuery
};


//////////////////
// WEBPACK FOOTER
// ./client/common.js
// module id = 140
// module chunks = 1